/** @jsx jsx */

import { css, jsx } from "@emotion/react";
import bgimg from "../../../images/wrap-series-bg.svg";
import { CarouselCommon } from "./CarouselCommon";
import SeriesCard from "./SeriesCard";
import nr from "../../../images/bg-nellie.png";
import is from "../../../images/bg-inspiration.png";
import marketing from "../../../images/bg-marketing.png";
import anatomy from "../../../images/bg-acadmy.png";
import ad from "../../../images/bg-advice.png";
import cb from "../../../images/bg-buzz.png";
import team from "../../../images/bg-team.png";
import bt from "../../../images/bg-branding-tomo.png";
import bb from "../../../images/bg-build-branding.png";

const seriesList = [
    {
        name:'Nellie Recommends',
        desc: 'Packaging tips to help your business grow',
        headImg: nr,
        slug: 'nellie-recommends',
        parent_slug: 'noissue-101'
    },
    {
        name:'Inspiration Station',
        desc: "Branding and design inspo from our community",
        headImg: is,
        slug: 'inspiration-station',
        parent_slug: 'noissue-101'
    },
    {
        name:'Marketing Masters',
        desc: "An educational marketing series for new brands",
        headImg: marketing,
        slug: 'marketingmasters',
        parent_slug: 'biz-advice'
    },
    {
        name:'Shaping Tomorrow',
        desc: "A guide to becoming a more sustainable business",
        headImg: bt,
        slug: 'hash-shapingtomorrow',
        parent_slug: 'tag'
    },
    {
        name:'Building A Brand',
        desc: "Creative advice to help build your brand identity",
        headImg: bb,
        slug: 'building-a-brand',
        parent_slug: 'biz-advice'
    },
    {
        name:'Creative Buzz',
        desc: "A spotlight on designers who are chasing their creative pursuits",
        headImg: cb,
        slug: 'hash-creativebuzz',
        parent_slug: 'biz-advice'
    },
    // {
    //     name:'Packaging Anatomy',
    //     desc: "Deconstructing packaging for different industries",
    //     headImg: anatomy,
    //     slug: 'hash-packaginganatomy',
    //     parent_slug: 'tag'
    // },
    {
        name:'noissue Team',
        desc: "The latest news on our noissue team and culture",
        headImg: team,
        slug: 'itsnoissue',
        parent_slug: 'tag'
    },
    {
        name:'Industry Advice',
        desc: "Expert advice for entrepreneurs, makers and creatives",
        headImg: ad,
        slug: 'industry-experts',
        parent_slug: 'tag'
    }


]

const WrapSeriesSection = () => {

    const cards = seriesList.map( (item, index) => {
        return { display:<SeriesCard post={item} id={index}/>, key: index}
    });

    return (
            <section
                css={css`
                    height: 85rem;
                    width: 100%;
                    position: relative;
                    background: url(${bgimg}) no-repeat top 5rem center,
                    linear-gradient( 180deg, #F8DEA1 81.08%, #FAD6C3 100%);

                    @media (max-width: 768px) {
                        background-size: contain;
                    }
                `}
            >
                <div css={css`
                    padding: 20rem 0rem 5rem 0;
                    @media (max-width: 768px) {
                        padding: 15rem 0rem 5rem 0;
                    }
                `}>
                    <CarouselCommon cards={cards} isSeries={true} />
                </div>
            </section>
    );
};

export default WrapSeriesSection;
